export const MODAL_NAME = 'orders.cancel-orderline'
export const FORM_ID = 'orders.cancel-orderline'

export const INITIAL_VALUES = {
  message: '',
}
